import { publishChallenge } from '@actions/challenges';
import {
    getChallengesIsPatching,
    getChallengesPatchError,
    getChallengesPatchSuccess,
} from '@selectors/challenges';
import { useDispatch, useSelector } from 'react-redux';

const usePublishChallenge = (challengeID: number, revert: boolean) => {
    const dispatch = useDispatch();

    const isPatching = useSelector(getChallengesIsPatching);
    const patchError = useSelector(getChallengesPatchError);
    const patchSuccess = useSelector(getChallengesPatchSuccess);

    const handleSubmit = () => {
        dispatch(publishChallenge(challengeID, revert));
    };

    return { isPatching, patchError, patchSuccess, handleSubmit };
};

export default usePublishChallenge;
